export class NotaFiscalSaidaListarRequest {
  /** Dia local da empresa ('yyyy-MM-dd'), sem fuso. */
  dataDe: string | null;
  /** Dia local da empresa ('yyyy-MM-dd'), sem fuso. */
  dataAte: string | null;
  pesquisar: string | null;
  listIdStatusNFeSaida: number[] | null;
  listIdVendedor: number[] | null;
  listIdTagNFeSaida: number[] | null;
  listIdProduto: number[] | null;
  listSerie: number[] | null;
  listIdFinalidadeNFe: number[] | null;
  /** Naturezas pelo id_nat_op, que é o que o lookup do MotorFiscal devolve. */
  listIdNatOp: number[] | null;
  /** Card de status selecionado (ResumoNotaFiscalSaidaEnum). */
  idResumoFiltro: number;
}
